import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";

export const useVisitor = () => {
  const [visitor, setVisitor] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    const onVisitor = (event) => { controller.abort(); setVisitor(event.detail); };
    window.addEventListener("pepe:visitor", onVisitor);
    if (!window.location.hash.includes("session_id=")) {
      axios.get(`${API}/visitor/me`, { withCredentials: true, signal: controller.signal })
        .then(({ data }) => { if (!controller.signal.aborted) setVisitor(data); })
        .catch(() => { if (!controller.signal.aborted) setVisitor(null); });
    }
    return () => { controller.abort(); window.removeEventListener("pepe:visitor", onVisitor); };
  }, []);
  const logout = async () => {
    try {
      await axios.post(`${API}/visitor/logout`, {}, { withCredentials: true });
      setVisitor(null);
      toast("Déconnecté de Google");
    } catch { toast.error("Déconnexion impossible, réessaie"); }
  };
  return { visitor, logout };
};